import { ca } from '@cian/analytics';

export function trackShowProjectsMap() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_map',
    useLastProducts: true,
  });
}
